import { SavedSignatureTemplate, UserGroup } from '../types';

const TEMPLATES_STORAGE_KEY = 'cerebrosign_saved_templates_';
const GROUPS_STORAGE_KEY = 'cerebrosign_user_groups_';

export const DEFAULT_SAVED_TEMPLATES: SavedSignatureTemplate[] = [
  {
    id: 'tpl_default',
    name: 'Szablon Firmowy (Modern Horizontal)',
    templateId: 'modern_horizontal',
    primaryColor: '#0284c7',
    companyName: 'CerebroLabs Sp. z o.o.',
    companyPhone: '+48 22 123 45 67',
    websiteUrl: 'https://cerebrolabs.io',
    nip: '5252824941',
    regon: '386928102',
    address: 'ul. Prosta 20, 00-850 Warszawa',
    logoUrl: 'https://cerebro-sign.web.app/img/signatures/cerebro-logo.png',
    logoWidth: 240,
    logoHeight: 68,
    bannerUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=520&auto=format&fit=crop&q=80',
    bannerLink: 'https://cerebrolabs.io',
    disclaimer: 'Treść tej wiadomości zawiera informacje poufne przeznaczone wyłącznie dla adresata.',
    createdAt: new Date().toISOString(),
    toggles: {
      showAvatar: true,
      avatarShape: 'circle',
      showJobTitle: true,
      showDepartment: true,
      showCompany: true,
      showPhone: true,
      showEmail: true,
      showWebsite: true,
      showTaxId: true,
      showAddress: true,
      showSocials: true,
      showBanner: true,
      showDisclaimer: true,
      showFreemiumBranding: true,
    },
  },
  {
    id: 'tpl_sales',
    name: 'Szablon Działu Sprzedaży (Marketing Focus)',
    templateId: 'marketing_focus',
    primaryColor: '#10b981',
    companyName: 'CerebroLabs Sp. z o.o.',
    companyPhone: '+48 22 123 45 67',
    websiteUrl: 'https://cerebrolabs.io',
    nip: '5252824941',
    regon: '386928102',
    address: 'ul. Prosta 20, 00-850 Warszawa',
    logoUrl: 'https://cerebro-sign.web.app/img/signatures/cerebro-logo.png',
    logoWidth: 240,
    logoHeight: 68,
    bannerUrl: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=520&auto=format&fit=crop&q=80',
    bannerLink: 'https://cerebrolabs.io/oferta',
    promoTitle: '⚡ Specjalna oferta chmurowa',
    promoText: 'Sprawdź nasze najnowsze rozwiązania chmurowe i pakiety dla firm.',
    promoCtaText: 'Umów rozmowę →',
    disclaimer: 'Zapoznaj się z aktualną ofertą rozwiązań chmurowych CerebroLabs.',
    createdAt: new Date().toISOString(),
    toggles: {
      showAvatar: true,
      avatarShape: 'rounded',
      showJobTitle: true,
      showDepartment: true,
      showCompany: true,
      showPhone: true,
      showEmail: true,
      showWebsite: true,
      showTaxId: false,
      showAddress: false,
      showSocials: true,
      showBanner: true,
      showDisclaimer: true,
      showFreemiumBranding: false,
    },
  },
  {
    id: 'tpl_executive',
    name: 'Szablon Zarządu (Corporate Compact)',
    templateId: 'corporate_compact',
    primaryColor: '#8b5cf6',
    companyName: 'CerebroLabs Sp. z o.o.',
    companyPhone: '+48 22 123 45 67',
    websiteUrl: 'https://cerebrolabs.io',
    nip: '5252824941',
    regon: '386928102',
    address: 'ul. Prosta 20, 00-850 Warszawa',
    logoUrl: 'https://cerebro-sign.web.app/img/signatures/cerebro-logo.png',
    logoWidth: 240,
    logoHeight: 68,
    bannerUrl: '',
    bannerLink: '',
    promoTitle: '',
    promoText: '',
    promoCtaText: '',
    disclaimer: 'Informacja poufna. CerebroLabs Sp. z o.o.',
    createdAt: new Date().toISOString(),
    toggles: {
      showAvatar: true,
      avatarShape: 'square',
      showJobTitle: true,
      showDepartment: true,
      showCompany: true,
      showPhone: true,
      showEmail: true,
      showWebsite: true,
      showTaxId: true,
      showAddress: true,
      showSocials: true,
      showBanner: false,
      showDisclaimer: true,
      showFreemiumBranding: false,
    },
  },
];

export const DEFAULT_USER_GROUPS: UserGroup[] = [
  {
    id: 'group_main',
    name: 'Grupa Główna (Wszyscy pracownicy)',
    description: 'Domyślna grupa dla wszystkich nowych pracowników domeny Google Workspace.',
    color: '#0284c7',
    savedTemplateId: 'tpl_default',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'group_sales',
    name: 'Dział Sprzedaży i Marketingu',
    description: 'Zespół handlowy z naciskiem na Call to Action i aktualne banery promocyjne.',
    color: '#10b981',
    savedTemplateId: 'tpl_sales',
    createdAt: new Date().toISOString(),
  },
  {
    id: 'group_executive',
    name: 'Zarząd i Dyrekcja',
    description: 'Kompaktowy, elegancki styl stopki bez dużych banerów marketingowych.',
    color: '#8b5cf6',
    savedTemplateId: 'tpl_executive',
    createdAt: new Date().toISOString(),
  },
];

export function getSavedTemplates(domain: string = 'cerebrolabs.io'): SavedSignatureTemplate[] {
  try {
    const raw = localStorage.getItem(`${TEMPLATES_STORAGE_KEY}${domain}`);
    if (!raw) {
      localStorage.setItem(`${TEMPLATES_STORAGE_KEY}${domain}`, JSON.stringify(DEFAULT_SAVED_TEMPLATES));
      return DEFAULT_SAVED_TEMPLATES;
    }
    const parsed: SavedSignatureTemplate[] = JSON.parse(raw);
    return parsed.map((item) => {
      const def = DEFAULT_SAVED_TEMPLATES.find((d) => d.id === item.id);
      return {
        ...def,
        ...item,
        toggles: {
          ...(def?.toggles || {}),
          ...(item.toggles || {}),
        },
      };
    });
  } catch (e) {
    console.warn('Error reading saved templates:', e);
    return DEFAULT_SAVED_TEMPLATES;
  }
}

export function saveTemplate(
  domain: string,
  template: Omit<SavedSignatureTemplate, 'id' | 'createdAt'> & { id?: string }
): SavedSignatureTemplate {
  const existing = getSavedTemplates(domain);
  const now = new Date().toISOString();

  let targetId = template.id || `tpl_${Date.now()}`;
  const existingIndex = existing.findIndex((t) => t.id === targetId);

  const newTemplate: SavedSignatureTemplate = {
    ...template,
    id: targetId,
    createdAt: existingIndex >= 0 ? existing[existingIndex].createdAt : now,
    updatedAt: now,
  };

  let updatedList: SavedSignatureTemplate[];
  if (existingIndex >= 0) {
    updatedList = [...existing];
    updatedList[existingIndex] = newTemplate;
  } else {
    updatedList = [newTemplate, ...existing];
  }

  localStorage.setItem(`${TEMPLATES_STORAGE_KEY}${domain}`, JSON.stringify(updatedList));
  return newTemplate;
}

export function deleteSavedTemplate(domain: string, templateId: string): void {
  const existing = getSavedTemplates(domain);
  const updated = existing.filter((t) => t.id !== templateId);
  localStorage.setItem(`${TEMPLATES_STORAGE_KEY}${domain}`, JSON.stringify(updated));
}

export function getUserGroups(domain: string = 'cerebrolabs.io'): UserGroup[] {
  try {
    const raw = localStorage.getItem(`${GROUPS_STORAGE_KEY}${domain}`);
    if (!raw) {
      localStorage.setItem(`${GROUPS_STORAGE_KEY}${domain}`, JSON.stringify(DEFAULT_USER_GROUPS));
      return DEFAULT_USER_GROUPS;
    }
    const parsed: UserGroup[] = JSON.parse(raw);
    const map = new Map<string, UserGroup>();
    DEFAULT_USER_GROUPS.forEach((g) => map.set(g.id, g));
    parsed.forEach((g) => map.set(g.id, { ...map.get(g.id), ...g }));
    return Array.from(map.values());
  } catch (e) {
    console.warn('Error reading user groups:', e);
    return DEFAULT_USER_GROUPS;
  }
}

/**
 * Sync user groups with Firestore under organizations/{domain}/groups
 * Remote Firestore is the source of truth across all devices/sessions.
 */
export async function syncUserGroupsWithFirestore(domain: string = 'cerebrolabs.io'): Promise<UserGroup[]> {
  try {
    const { fetchGroupsFromFirestore } = await import('./signaturePersistenceService');
    const remote = await fetchGroupsFromFirestore(domain);
    const local = getUserGroups(domain);

    const mergedMap = new Map<string, UserGroup>();
    // 1. Defaults as baseline
    DEFAULT_USER_GROUPS.forEach((g) => mergedMap.set(g.id, g));
    // 2. Local storage customizations
    local.forEach((g) => mergedMap.set(g.id, { ...mergedMap.get(g.id), ...g }));
    // 3. Remote Firestore as highest priority source of truth
    if (remote && remote.length > 0) {
      remote.forEach((g) => mergedMap.set(g.id, { ...mergedMap.get(g.id), ...g }));
    }

    const mergedList = Array.from(mergedMap.values());
    localStorage.setItem(`${GROUPS_STORAGE_KEY}${domain}`, JSON.stringify(mergedList));
    return mergedList;
  } catch (e) {
    console.warn('Error syncing groups with Firestore:', e);
    return getUserGroups(domain);
  }
}

export function saveUserGroup(
  domain: string,
  group: Omit<UserGroup, 'id' | 'createdAt'> & { id?: string }
): UserGroup {
  const existing = getUserGroups(domain);
  const now = new Date().toISOString();

  let targetId = group.id || `group_${Date.now()}`;
  const existingIndex = existing.findIndex((g) => g.id === targetId);

  const newGroup: UserGroup = {
    ...group,
    id: targetId,
    createdAt: existingIndex >= 0 ? existing[existingIndex].createdAt : now,
  };

  let updatedList: UserGroup[];
  if (existingIndex >= 0) {
    updatedList = [...existing];
    updatedList[existingIndex] = newGroup;
  } else {
    updatedList = [...existing, newGroup];
  }

  localStorage.setItem(`${GROUPS_STORAGE_KEY}${domain}`, JSON.stringify(updatedList));

  // Sync to Firestore asynchronously
  import('./signaturePersistenceService')
    .then(({ saveGroupToFirestore }) => saveGroupToFirestore(domain, newGroup))
    .catch((err) => console.warn('Async saveGroupToFirestore error:', err));

  return newGroup;
}

export function deleteUserGroup(domain: string, groupId: string): void {
  if (groupId === 'group_main') {
    throw new Error('Nie można usunąć Grupy Głównej.');
  }
  const existing = getUserGroups(domain);
  const updated = existing.filter((g) => g.id !== groupId);
  localStorage.setItem(`${GROUPS_STORAGE_KEY}${domain}`, JSON.stringify(updated));

  // Delete from Firestore asynchronously
  import('./signaturePersistenceService')
    .then(({ deleteGroupFromFirestore }) => deleteGroupFromFirestore(domain, groupId))
    .catch((err) => console.warn('Async deleteGroupFromFirestore error:', err));
}

